import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@sm/wds-react';
import AppPlaceHolderImg from '../../static/images/app-placeholder.png';
// LinkWithSearch should be used so it will keep any existing query arguments present in the url (needed for ut_source)
import AppLink from '../AppLink';

import './app-listing-list.scss';

const AppListingList = ({ title, apps }) => (
  <>
    <If condition={title}>
      <Typography variant="pageTitle">{title}</Typography>
    </If>

    <div className="sm-app-listing-list">
      {apps.map(app => (
        <AppLink
          app={app}
          key={app.id}
          className="sm-app-listing-list__link"
          data-testid="AppListingList_Link"
        >
          <div className="sm-app-listing-list__app wds-flex wds-p-5 wds-m-b-3">
            <div>
              <img
                src={app.logo ? app.logo : AppPlaceHolderImg}
                alt={app.name}
                className="sm-app-listing-list__app-logo wds-m-r-5"
              />
            </div>
            <div className="sm-app-listing-list__app-description">
              <Typography variant="cardTitle">{app.name}</Typography>
              <Typography color="dark-muted">{app.tagline}</Typography>
            </div>
          </div>
        </AppLink>
      ))}
    </div>
  </>
);

AppListingList.propTypes = {
  title: PropTypes.string,
  apps: PropTypes.arrayOf(
    PropTypes.shape({
      links: PropTypes.shape({
        detail: PropTypes.string.isRequired
      }).isRequired,
      id: PropTypes.string.isRequired,
      logo: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      tagline: PropTypes.string
    })
  ).isRequired
};

AppListingList.defaultProps = {
  title: null
};

export default AppListingList;
